
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { downloadCSV } from "src/store/slices/callSlice";
import { CALL, DOWNLOADCSV, FULFILLED } from "src/common/constants";
import { composeThunkAction } from "src/common/utils";
import { toast } from "react-toastify";

const CallReportModal = () => {
    const dispatch: ThunkDispatch<object, object, any> = useDispatch();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const formattedDate = (date: any) => date.toISOString().split('T')[0];
        setStartDate(formattedDate(yesterday));
        setEndDate(formattedDate(today));
    }, []);

    const handleDownloadCSV = async () => {
        try {
            const startDateObj = new Date(startDate);
            const endDateObj = new Date(endDate);
            if (isNaN(startDateObj.getTime()) || isNaN(endDateObj.getTime())) {
                toast.error('Invalid date format.');
                return;
            }
            if (!startDate || !endDate) {
                toast.error('Please select both start and end dates.');
                return;
            }
            if (new Date(startDate) > new Date(endDate)) {
                toast.error('Start date cannot be greater than end date.');
                return;
            }
            const timezoneOffset = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formatDateWithoutZ = (dateObj: any) => {
                const year = dateObj.getUTCFullYear();
                const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
                const day = String(dateObj.getUTCDate()).padStart(2, '0');
                const hours = String(dateObj.getUTCHours()).padStart(2, '0');
                const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
                const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            };
            const startDateFormatted = formatDateWithoutZ(startDateObj);
            const endFormattedDate = formatDateWithoutZ(endDateObj)
            const endDateNextDayObj = new Date(endDateObj);
            endDateNextDayObj.setUTCDate(endDateNextDayObj.getUTCDate() + 1);
            const endDateFormatted = formatDateWithoutZ(endDateNextDayObj);
            const data = {
                startDate: startDateFormatted,
                endDate: endFormattedDate,
                timezoneOffset: timezoneOffset
            };
            const response = await dispatch(downloadCSV(data));
            if (response?.type === `${composeThunkAction(CALL, DOWNLOADCSV)}/${FULFILLED}`) {
                if (response.payload && response.payload.data) {
                    const file = new Blob([response.payload.data], { type: 'text/xlsx' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(file);
                    const fileName = `${startDateFormatted}-to-${endFormattedDate}-booking-history.xlsx`;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    toast.error('No data found for the selected date range.');
                }
            } else if (response?.payload?.statusCode === 400) {
                toast.error('No data found for the selected date range.');
            } else {
                toast.error('Unexpected error occurred while downloading the CSV.');
            }
        } catch (error: any) {
            console.error('Error downloading CSV:', error);
            toast.error(`Error downloading CSV: ${error.message}`);
        }
    };
    const today = new Date().toISOString().split('T')[0];

    return (
        <div className="bg-white p-4 rounded shadow">
            <div className="mb-2">
                <div className="d-flex align-items-center mb-2">
                    <label htmlFor="custom-date-range" className="text-dark">Custom date range</label>
                </div>
                <div className="d-flex gap-2">
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        max={today}
                    />
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        max={today}
                    />
                </div>
            </div>
            <div>
                <button className="btn btn-primary d-flex align-items-center justify-content-between rounded px-4 py-2 mt-3" onClick={handleDownloadCSV}>Apply</button>
            </div>
        </div>
    );
}

export default CallReportModal;
